// Mirrors FLAT_PRICE_CURRENCIES in magellan-api `models/account.js` — anything
// outside this list comes back from PUT /api/admin/accounts/:accountId as a 422.
// Also drives the invoice currency picker (see invoiceCurrencyOptions in
// invoiceDisplay.js), which happens to price in the same currencies today.
const flatPriceCurrencies = [
  'EUR',
  'USD',
  'GBP',
  'CHF',
  'CAD',
  'AUD',
  'JPY',
  'SEK',
  'NOK',
  'DKK',
  'PLN',
  'CZK',
  'HUF',
  'RON',
  'TRY',
];

export default flatPriceCurrencies;
